import React, { Component } from "react";
import GoogleMapsControl from "./GoogleMapsController";
import { GOOGLE_MAPS_CONFIG } from "../constants";
import PropTypes from "prop-types";
import GoogleMapsLoader from "google-maps";
import { TextField, Input, Button } from "@material-ui/core/";
Object.assign(GoogleMapsLoader, GOOGLE_MAPS_CONFIG);

export default class GoogleMapsWithControls extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount = () => {
    let self = this;
    //console.log("GoogleMapsWithControls-projectData",self.props.projectData);
    GoogleMapsLoader.load(google => {
      let mapCtrl = new GoogleMapsControl(
        google,
        self.props.projectData,
        self.props.setStateCallback,
        self.props.defaultSetup
      );
      self.mapCtrl = mapCtrl;
      mapCtrl.initMap(self.refs.map, self.refs.searchBox);
    });
  };
  /* shouldComponentUpdate() {
    return false;
  } */

  render() {
    return (
      <div >
        <input
          ref="searchBox"
          
          className="google-map-search"
          type="text"
          placeholder="Project address"
        />

        <div className="google-map-edit" ref="map" />
      </div>
    );
  }
}

GoogleMapsWithControls.propTypes = {
  projectData: PropTypes.object.isRequired,
  setStateCallback: PropTypes.func.isRequired
};
